module.exports = __webpack_public_path__ + "img/we-think.bf357ddf.webp";